const ssrStub = {
  identify: () => {},
  track: () => {},
  ready: () => {},
};

export default window.analytics;
